export interface ProjectRoot {
  '@odata.context': string;
  value: Project[];
}

export interface Project {
  '@odata.etag': string;
  projectNo: string;
  projectCategory: string;
  projectName: string;
  projectDescription: string;
  projectManager: string;
  customerNo: string;
  customerName: string;
  customerProjectManage: string;
  contactEmail: string;
  contactPhoneNo: string;
  projectStartDate: string;
  projectEndDate: string;
  projectMinEstHours: number;
  projectMaxEstHours: number;
  projectStatus: string;
  projectPercentComplete: number;
  phaseNoTemp: string;
  genBusPostingGroup: string;
  timeBillingOption: string;
  billingRateOption: string;
  defaultBillingRate: number;
  defaultResourceNo: string;
  actualHours: number;
  ganttTimelineMode: string;
  ganttTimelineWidth: number;
  revenueAmountHours: number;
  costAmountHours: number;
  lastInvoiceDate: string;
  salesInvoiceCountCreated: number;
  timesheetNotInvoiceCount: number;
}

export class ProjectDomain {
  newProjects: Project[];

  constructor(newProjects?: Project[]) {
    this.newProjects = newProjects ?? [];
  }

  toJsonList(currentProjects: Record<string, Project>): Record<string, Project> {
    this.newProjects.forEach((project) => {
      if (project.projectNo) {
        currentProjects[project.projectNo] = project;
      }
    });

    return currentProjects;
  }

  toList(currentProjects: Record<string, Project>): Project[] {
    return Object.values(currentProjects);
  }
}
